export default __webpack_public_path__ + "static/media/Walker's Fauld of the Seven Suns.cf45ae26.jpg";